module.exports = __webpack_public_path__ + "static/media/logo.73eabd82.png";


//////////////////
// WEBPACK FOOTER
// ./src/isaver-quote/images/logo.png
// module id = 345
// module chunks = 0